const STAGE_PREFIXES = ["_STAGE_", "_PROD_", "_DEV_"];

const sanitizeEnvValue = (value) => {
  if (!value) return undefined;

  for (const prefix of STAGE_PREFIXES) {
    if (value.startsWith(prefix)) {
      return value.replace(prefix, "");
    }
  }
  return value;
};

const envConfig = {
  ENV_TYPE: sanitizeEnvValue(process.env.ENV_TYPE),
  NEXT_PUBLIC_BLOGS_ENDPOINT: sanitizeEnvValue(
    process.env.NEXT_PUBLIC_BLOGS_ENDPOINT
  ),
  NEXT_PUBLIC_BLOGS_ACCESS_TOKEN: sanitizeEnvValue(
    process.env.NEXT_PUBLIC_BLOGS_ACCESS_TOKEN
  ),
  NEXT_PUBLIC_BLOGS_LOCALE: sanitizeEnvValue(
    process.env.NEXT_PUBLIC_BLOGS_LOCALE
  ),
  NEXT_PUBLIC_BLOGS_DOMAIN: sanitizeEnvValue(
    process.env.NEXT_PUBLIC_BLOGS_DOMAIN
  ),
};

/**
 * Prints all raw environment variables with the original prefixes
 */
const printOriginalEnv = () => {
  console.log("📦 Raw Environment Variables:", Object.keys(envConfig));
};

module.exports = {
  envConfig,
  printOriginalEnv,
};
